import { createRouter, createWebHistory } from 'vue-router';

import { useAuthStore } from '../store/auth';

const DashboardView = () => import('../views/DashboardView.vue');
const ResolutionsView = () => import('../views/ResolutionsView.vue');
const ResolutionDetailView = () => import('../views/ResolutionDetailView.vue');
const ProtocolsView = () => import('../views/ProtocolsView.vue');
const ProtocolDetailView = () => import('../views/ProtocolDetailView.vue');
const AgendaListView = () => import('../views/AgendaListView.vue');
const AgendaDetailView = () => import('../views/AgendaDetailView.vue');
const TodoListView = () => import('../views/TodoListView.vue');
const DocumentsView = () => import('../views/DocumentsView.vue');
const DocumentDetailView = () => import('../views/DocumentDetailView.vue');
const AdminView = () => import('../views/AdminView.vue');
const LoginView = () => import('../views/LoginView.vue');
const ProfileView = () => import('../views/ProfileView.vue');
const NotificationSettingsView = () => import('../views/NotificationSettingsView.vue');
const OidcCallbackView = () => import('../views/OidcCallbackView.vue');
const FaqView = () => import('../views/FaqView.vue');
const SearchView = () => import('../views/SearchView.vue');
const NotFoundView = () => import('../views/NotFoundView.vue');

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'dashboard', component: DashboardView },
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    { path: '/oidc-callback', name: 'oidc-callback', component: OidcCallbackView, meta: { public: true } },
    { path: '/resolutions', name: 'resolutions', component: ResolutionsView },
    {
      path: '/resolutions/:id',
      name: 'resolution-detail',
      component: ResolutionDetailView,
      props: (route) => ({ id: Number(route.params.id) }),
    },
    {
      path: '/vote/:token',
      name: 'resolution-token',
      component: ResolutionDetailView,
      props: (route) => ({ token: route.params.token }),
    },
    { path: '/protocols', name: 'protocols', component: ProtocolsView },
    { path: '/protocols/new', name: 'protocol-create', component: ProtocolDetailView, props: { mode: 'create' } },
    {
      path: '/protocols/:id',
      name: 'protocol-detail',
      component: ProtocolDetailView,
      props: (route) => ({ id: route.params.id }),
    },
    { path: '/agendas', name: 'agendas', component: AgendaListView },
    {
      path: '/agendas/:id',
      name: 'agenda-detail',
      component: AgendaDetailView,
      props: (route) => ({ id: Number(route.params.id) }),
    },
    { path: '/todos', name: 'todos', component: TodoListView },
    { path: '/documents', name: 'documents', component: DocumentsView },
    {
      path: '/documents/:id',
      name: 'document-detail',
      component: DocumentDetailView,
      props: (route) => ({ id: Number(route.params.id) }),
    },
    { path: '/faq', name: 'faq', component: FaqView, meta: { public: true } },
    { path: '/search', name: 'search', component: SearchView },
    { path: '/admin', name: 'admin', component: AdminView, meta: { requiresSysadmin: true } },
    { path: '/profile', name: 'profile', component: ProfileView },
    { path: '/settings/notifications', name: 'notification-settings', component: NotificationSettingsView },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundView, meta: { public: true } },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (to.query.oidc_token) {
    try {
      await auth.completeOidcLogin(String(to.query.oidc_token));
    } catch (error) {
      console.error('OIDC login failed', error);
      return { name: 'login', replace: true };
    }
    const { oidc_token, ...query } = to.query;
    return { path: to.path, query, hash: to.hash, replace: true };
  }
  if (!auth.isInitialized) {
    await auth.initialize();
  }
  if (to.meta.public) {
    if (auth.isAuthenticated && to.name === 'login') {
      return { name: 'dashboard' };
    }
    return true;
  }
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }
  if (to.meta.requiresSysadmin && !auth.isSysadmin) {
    return { name: 'dashboard' };
  }
  return true;
});

export default router;
